import {NgModule} from '@angular/core';
import {EnumerationService} from './enumeration.service';

@NgModule({
  providers: [
    EnumerationService
  ]
})
export class EnumerationModule {
}



// WEBPACK FOOTER //
// /var/jenkins_home/workspace/brands-compart-portal-frontend/checkout/src/app/components/enumeration/enumeration.module.ts